import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import toastr from '../../toastr';
import BreakLunch from './modes/mechanics/BreakLunch';
import ChangeJob from './modes/mechanics/ChangeJob';
import EarlyTime from './modes/mechanics/EarlyTime';
import NextRepairOrder from './modes/mechanics/NextRepairOrder';
import OffWork from './modes/mechanics/OffWork';
import PartsRequest from './modes/mechanics/PartsRequest';
import ROStory from './modes/mechanics/ROStory';
import SendMessage from './modes/mechanics/SendMessage';
import ShopTime from './modes/mechanics/ShopTime';
import ViewStory from './modes/mechanics/ViewStory';
import ViewTime from './modes/mechanics/ViewTime';
import ViewHistory from './modes/mechanics/ViewHistory';
import WorkersCompCode from './modes/mechanics/WorkersCompCode';
import GenericMode from './modes/mechanics/GenericMode';
import ViewTimeExtended from './modes/mechanics/ViewTimeExtended';

/* Each implemented mode should:
  1. provide its own .process() and validation logic which should
     return a promise.  resolve indicates the process was successful.
     reject means the request to process was unsuccessful, either due
     to form invalidation, or D3/QM error responses.
  2. focus to its first input on mount for fast UX

   - most modes share logic (including process logic) which can be
     found in ModeComponent, a base class all modes extend.
     ViewStory, ViewTime, and PartsRequest override process logic.
*/

export default class MechanicsModeConductor extends Component {
  static propTypes = {
    activeStory: PropTypes.bool.isRequired,
    mode: PropTypes.string.isRequired,
    reset: PropTypes.func,
    userActive: PropTypes.string.isRequired,
    password: PropTypes.string,
    modes: PropTypes.object,
    hideOpComplete: PropTypes.bool,
    hideRemedyCode: PropTypes.bool,
    hideMileage: PropTypes.bool,
  };

  onProcess = () => {
    this.activeModeRef
      .process(this.props.userActive, this.props.password)
      .then(successMsg => {
        toastr.success('Action processed.', successMsg);
        this.props.reset();
      })
      .catch(errorMsg => {
        if (!!errorMsg) {
          toastr.error('Error!', errorMsg);
        }
      });
  };

  setActiveModeRef = ref => {
    this.activeModeRef = ref;
  };

  render() {
    let modeRender;

    switch (this.props.mode) {
      case 'BK':
        modeRender = (
          <BreakLunch
            ref={this.setActiveModeRef}
            activeStory={this.props.activeStory}
            hideOpComplete={this.props.hideOpComplete}
            hideRemedyCode={this.props.hideRemedyCode}
            causeText={this.props.causeText}
            correctionText={this.props.correctionText}
          />
        );
        break;
      case 'CJ':
        modeRender = <ChangeJob ref={this.setActiveModeRef} />;
        break;
      case 'ET':
        modeRender = <EarlyTime ref={this.setActiveModeRef} />;
        break;
      case 'NR':
        modeRender = (
          <NextRepairOrder
            ref={this.setActiveModeRef}
            activeStory={this.props.activeStory}
            hideOpComplete={this.props.hideOpComplete}
            hideRemedyCode={this.props.hideRemedyCode}
            hideMileage={this.props.hideMileage}
            lastPunch={this.props.lastPunch}
            causeText={this.props.causeText}
            correctionText={this.props.correctionText}
          />
        );
        break;
      case 'OW':
        modeRender = (
          <OffWork
            ref={this.setActiveModeRef}
            activeStory={this.props.activeStory}
            hideOpComplete={this.props.hideOpComplete}
            hideRemedyCode={this.props.hideRemedyCode}
            causeText={this.props.causeText}
            correctionText={this.props.correctionText}
          />
        );
        break;
      case 'PR':
        modeRender = <PartsRequest ref={this.setActiveModeRef} />;
        break;
      case 'RS':
        modeRender = <ROStory ref={this.setActiveModeRef} />;
        break;
      case 'SM':
        modeRender = <SendMessage ref={this.setActiveModeRef} />;
        break;
      case 'ST':
        modeRender = <ShopTime ref={this.setActiveModeRef} activeStory={this.props.activeStory} />;
        break;
      case 'VH':
        modeRender = <ViewHistory ref={this.setActiveModeRef} />;
        break;
      case 'VS':
        modeRender = <ViewStory ref={this.setActiveModeRef} />;
        break;
      case 'VT':
        modeRender = <ViewTime ref={this.setActiveModeRef} />;
        break;
      case 'VB':
        modeRender = <ViewTimeExtended ref={this.setActiveModeRef} />;
        break;
      case 'WC':
        modeRender = <WorkersCompCode ref={this.setActiveModeRef} />;
        break;
      default:
        modeRender = (
          <GenericMode
            ref={this.setActiveModeRef}
            activeStory={this.props.activeStory}
            mode={this.props.mode}
            {...this.props.modes[this.props.mode]}
          />
        );
    }

    return (
      <div className="tc-mode-conductor">
        {modeRender}
        <Button variant="success" className="float-right" onClick={this.onProcess} id="processButton">
          Process
        </Button>
      </div>
    );
  }
}
